import api from './client'

// SISTEMA → Memoria de agentes IA (1 oct 2026, Cerebro Comercial etapa 1):
// las reglas de todos los agentes en un solo lugar, y si cada agente las usa.
export const agentesMemoriaApi = {
  listar: () => api.get('/agentes/memoria'),
  versiones: (id) => api.get(`/agentes/memoria/${id}/versiones`),
  crear: (data) => api.post('/agentes/memoria', data),
  editar: (id, data) => api.put(`/agentes/memoria/${id}`, data),
  aprobar: (id, alcance) => api.post(`/agentes/memoria/${id}/aprobar`, { alcance }),
  archivar: (id, motivo) => api.post(`/agentes/memoria/${id}/archivar`, { motivo }),
  reactivar: (id) => api.post(`/agentes/memoria/${id}/reactivar`),
}
